import { render, staticRenderFns } from "./RetailerAddress.vue?vue&type=template&id=5c42acdc&lang=pug"
import script from "./RetailerAddress.vue?vue&type=script&lang=js"
export * from "./RetailerAddress.vue?vue&type=script&lang=js"
import style0 from "./RetailerAddress.vue?vue&type=style&index=0&id=5c42acdc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports